import { Component, OnInit } from '@angular/core';
import { UserService } from '../_services/user.service';
import { NotificationService } from 'src/app/_services/notification.service'
import { User } from '../_models';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-customer-detail',
  templateUrl: './customer-detail.component.html',
  styleUrls: ['./customer-detail.component.css']
})
export class CustomerDetailComponent implements OnInit {

  cUser:User ;
  loading:boolean = false;
  submitted:boolean = false;

  userID: string;

  constructor(public service: UserService,  
    private notifyService : NotificationService,
    private fb: FormBuilder,
    private router: Router,
    private route:ActivatedRoute,
    public userService: UserService
    ) { }

  ngOnInit(): void {
    this.cUser = JSON.parse(localStorage.getItem('currentUser'));   
   
    this.route.paramMap.subscribe(param => {
      this.userID = param.get('userID');
      if(this.userID){
        this.loadUserdetails(this.userID);
      }      
    });
  }

  formModel = this.fb.group({
    Email: ['', [Validators.required, Validators.email]],
    FirstName: [''],
    LastName: [''],
    CompanyName: ['',Validators.required],
    Mobile:[''] ,
    Status:['',Validators.required],
    PartnerCenterID:['',Validators.required],// For Update Customer Component
  });



  loadUserdetails(userId){
    this.userService.getCusomerDetail(userId).subscribe(
      res => {
        if(res!= null){                             
             this.formModel.controls.FirstName.setValue(res.firstName);
             this.formModel.controls.LastName.setValue(res.lastName);
             this.formModel.controls.Mobile.setValue(res.phoneNumber);
             this.formModel.controls.Email.setValue(res.email);
             this.formModel.controls.CompanyName.setValue(res.companyName);
             this.formModel.controls.Status.setValue(res.status);
             this.formModel.controls.PartnerCenterID.setValue(res.partnerCenterId);// For Update Customer Component
        }       
      },
      err => {
       //this.router.navigate(['/']);
      }
    );
  }

  
  onSubmit() {

    this.submitted =  true;

    if (!this.formModel.valid) {
      //  this.notifyService.showError("All fields are required.", "Error.")
        return;
      }          

    this.loading = true;
  
    var param = {
      Id:this.userID,
      UserName: this.formModel.value.UserName,
      PhoneNumber : this.formModel.value.Mobile,
      CompanyName: this.formModel.value.CompanyName,               
      Email: this.formModel.value.Email,
      FirstName: this.formModel.value.FirstName,
      LastName: this.formModel.value.LastName,    
      Status : parseInt(this.formModel.value.Status) ,        
      CreatedBy : this.cUser.userId,
      PartnerCenterId : this.formModel.value.PartnerCenterID // For Update Customer Component
    }; 
    this.userService.updateCustomer(param)
        .subscribe( 
            data => {              
              if(data){
     
                this.loading = false;                
     
                this.submitted = false;
                this.notifyService.showSuccess("Saved successfully", "CSP Portal");                            
            }
          },
            error => {                
                this.loading = false;  
                this.submitted = false;                           
            });          
    }  
    
    onClose(){
      this.router.navigate(['/customers']);
    }
}
